import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _createSuper from "@babel/runtime/helpers/createSuper";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _pick from "lodash/pick";
import _get from "lodash/get";
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { Impression } from '@nerdwallet/analytics/react/impression';
import * as actions from '../redux/actions';
import CompareCTA from './compare-cta';
import './compare-card-sticky.less';
/**
 * The compare card sticky renders the compare card CTA seen across the bottom of the credit cards
 * tool. This is the experimental version with slightly different layout, a lighter background,
 * and supports an animation when a user adds a card to the compare list.
 *
 * Shows a count of cards to compare with cta to navigate to the comparison
 * page or clear their comparisons. On the comparison page, provides an option to navigate back to
 * the page they came from. This is the Component that gets exported.
 *
 * @class
 */

export var CompareCardSticky = /*#__PURE__*/function (_React$Component) {
  _inherits(CompareCardSticky, _React$Component);

  var _super = _createSuper(CompareCardSticky);

  function CompareCardSticky() {
    _classCallCheck(this, CompareCardSticky);

    return _super.apply(this, arguments);
  }

  _createClass(CompareCardSticky, [{
    key: "componentWillUpdate",
    value: // eslint-disable-next-line react/no-deprecated -- directive added automatically by Shepherd migration
    function componentWillUpdate() {
      // So the sticky bar does not cover footer text when the user scrolls all the way down
      if (this.isStickyActive()) {
        document.querySelector('body').style.paddingBottom = '60px';
      } else {
        document.querySelector('body').style.paddingBottom = '0';
      }
    }
  }, {
    key: "isStickyActive",
    value: function isStickyActive() {
      return this.props.isCompareCardsBusy || this.props.forceActive || this.props.compareCards.cardIDsToCompare.length;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$analytics, _this$props$analytics2, _this$props$analytics3;

      var active = this.isStickyActive();
      var stickyClasses = classNames('compare-sticky', {
        active: active,
        'with-card-images': this.props.showCardImages
      });
      var numCardsToCompare = _get(this.props, 'compareCards.cardIDsToCompare.length') || 0;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: stickyClasses
      }, active ? /*#__PURE__*/React.createElement(Impression, {
        entityName: "cc_compare_cards_banner",
        enabled: (_this$props$analytics = this.props.analytics) === null || _this$props$analytics === void 0 ? void 0 : _this$props$analytics.enabled,
        payload: {
          section_name: (_this$props$analytics2 = this.props.analytics) === null || _this$props$analytics2 === void 0 ? void 0 : (_this$props$analytics3 = _this$props$analytics2.payload) === null || _this$props$analytics3 === void 0 ? void 0 : _this$props$analytics3.sectionName
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "sticky-content"
      }, /*#__PURE__*/React.createElement(CompareCTA, {
        isCompareCardsBusy: this.props.isCompareCardsBusy,
        numCardsToCompare: numCardsToCompare,
        clearCompareList: this.props.clearCompareList,
        removeFromCompare: this.props.removeFromCompare,
        saveToCompare: this.props.saveToCompare,
        showBackButton: this.props.showBackButton,
        history: this.props.history,
        buttonClassName: "ripply bubbly",
        isLinkToSameApp: this.props.isLinkToSameApp,
        overrideCTA: this.props.overrideCTA,
        ctaText: this.props.ctaText,
        mobileCtaText: this.props.mobileCtaText,
        disableReset: this.props.disableReset,
        showCardImages: this.props.showCardImages,
        showAddCard: this.props.showAddCard,
        cardsToCompare: this.props.compareCards.cardsToCompare,
        offerSDK: this.props.offerSDK,
        cardIDsToCompare: _get(this.props, 'compareCards.cardIDsToCompare'),
        taxonomy: this.props.taxonomy,
        analytics: this.props.analytics
      }))) : null));
    }
  }]);

  return CompareCardSticky;
}(React.Component);

_defineProperty(CompareCardSticky, "propTypes", {
  // eslint-disable-next-line react/require-default-props
  clearCompareList: PropTypes.func,
  compareCards: PropTypes.shape({
    cardIDsToCompare: PropTypes.arrayOf(PropTypes.number),
    // eslint-disable-next-line react/forbid-prop-types -- directive added automatically by Shepherd migration
    cardsToCompare: PropTypes.object
  }),
  // eslint-disable-next-line react/require-default-props
  ctaText: PropTypes.objectOf(PropTypes.string),
  // eslint-disable-next-line react/require-default-props
  mobileCtaText: PropTypes.shape({
    cta: PropTypes.string
  }),
  // eslint-disable-next-line react/require-default-props
  disableReset: PropTypes.bool,
  analytics: PropTypes.shape({
    enabled: PropTypes.bool,
    payload: PropTypes.shape({
      sectionName: PropTypes.string
    })
  }),
  // eslint-disable-next-line react/require-default-props
  forceActive: PropTypes.bool,
  // eslint-disable-next-line react/require-default-props
  history: PropTypes.shape({
    goBack: PropTypes.func
  }),
  // eslint-disable-next-line react/require-default-props
  isCompareCardsBusy: PropTypes.bool,
  isLinkToSameApp: PropTypes.bool,
  offerSDK: PropTypes.shape({}).isRequired,
  // eslint-disable-next-line react/require-default-props
  overrideCTA: PropTypes.node,
  // eslint-disable-next-line react/require-default-props
  removeFromCompare: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  saveToCompare: PropTypes.func,
  showAddCard: PropTypes.bool,
  // eslint-disable-next-line react/require-default-props
  showBackButton: PropTypes.bool,
  showCardImages: PropTypes.bool,
  taxonomy: PropTypes.shape({})
});

_defineProperty(CompareCardSticky, "defaultProps", {
  isLinkToSameApp: false,
  compareCards: {
    cardIDsToCompare: [],
    cardsToCompare: {}
  },
  analytics: {
    enabled: false
  },
  showCardImages: false,
  showAddCard: false,
  taxonomy: {}
});

var mapStateToProps = function mapStateToProps(state) {
  var mappedState = _pick(state, ['compareCards', 'ctaText', 'disableReset', 'experiments', 'forceActive', 'history', 'isLinkToSameApp', 'overrideCTA', 'showAddCard', 'showBackButton', 'showCardImages']);

  mappedState.isCompareCardsBusy = _get(state, 'compareCards.isCompareCardsBusy');
  return mappedState;
};

var mapDispatchToProps = {
  clearCompareList: actions.clearCompareList,
  removeFromCompare: actions.removeFromCompare,
  saveToCompare: actions.saveToCompare
};
/**
 * We connect to our own removeFromCompare action. But in cc-client, we want to be able to override
 * it with a wrapper that causes the compare-cards page to be updated.
 *
 * @function
 * @param {Object} stateProps - props as provided by mapStateToProps.
 * @param {Object} dispatchProps - props as provided by mapDispatchToProps
 * @param {Object} ownProps - props as provided by the parent element.
 * @returns {Object} - a merged prop with ownProps taking precedence over dispatchProps and
 *                     stateProps (in that order).
 */

var mergeProps = function mergeProps(stateProps, dispatchProps, ownProps) {
  return _objectSpread(_objectSpread(_objectSpread({}, stateProps), dispatchProps), ownProps);
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(CompareCardSticky);